var plugin_rtlignore_default = {
  "alignLeft": "HrKdN",
  "textWrapNowrap": "Sie1q",
  "alignRight": "Mmbgf",
  "alignCenter": "_5Llbo",
  "sizeFullWidth": "dsbHU",
  "renderedInTable": "_5r-S8",
  "sizeOriginal": "TTSNf",
  "sizeContent": "kIU8W",
  "sizeSmall": "hvsag",
  "sizeSmallCenter": "xukke",
  "flex": "mEpxz",
  "atomic": "eqS3g",
  "embed": "GXfO1",
  "horizontalScrollbar": "CrYPK",
  "pluginContainerMobile": "_1s3JW"
};
export {
  plugin_rtlignore_default as default
};
//# sourceMappingURL=plugin.rtlignore-scss.js.map
